export default "__VITE_ASSET__idg9cyl1__"